/**
 * Colour-swatch behaviour for the custom product card
 * (snippets/custom-product-card.liquid).
 *
 * Bound once at the document level so it survives:
 *  - section morphs from filtering/sorting on the collection page
 *  - cards appended by infinite scroll
 *  - the hydration morph that injects product recommendations
 *
 * Loading this file more than once is harmless — the flag guards re-binding.
 */
(function () {
  if (window.__ccpSwatchesBound) return;
  window.__ccpSwatchesBound = true;

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-ccp-swatch]');
    if (!swatch) return;

    // The card's media link sits underneath; never navigate on swatch click.
    event.preventDefault();
    event.stopPropagation();

    var card = swatch.closest('[data-ccp-card]');
    if (!card) return;

    var group = swatch.closest('[data-ccp-swatches]');
    if (group) {
      group.querySelectorAll('[data-ccp-swatch]').forEach(function (other) {
        other.classList.toggle('is-active', other === swatch);
      });
    }

    // Match the <img> only — products without media render a placeholder <svg>.
    var image = card.querySelector('img.ccp-card__image');
    var src = swatch.getAttribute('data-image');
    if (image && src) {
      // Drop the responsive attributes so the explicit src wins.
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
    }

    var url = swatch.getAttribute('data-url');
    if (url) {
      card
        .querySelectorAll('[data-ccp-button], [data-ccp-title-link], [data-ccp-media-link]')
        .forEach(function (link) {
          link.href = url;
        });
    }

    var price = card.querySelector('[data-ccp-price]');
    if (price && swatch.getAttribute('data-price')) {
      price.textContent = swatch.getAttribute('data-price');
    }

    var compare = card.querySelector('[data-ccp-compare]');
    var discount = card.querySelector('[data-ccp-discount]');
    var compareValue = swatch.getAttribute('data-compare');
    var discountValue = swatch.getAttribute('data-discount');

    if (compare) {
      compare.textContent = compareValue || '';
      compare.hidden = !compareValue;
    }
    if (discount) {
      discount.textContent = discountValue ? discountValue + '% OFF' : '';
      discount.hidden = !discountValue;
    }
  });
})();
